// Compute the cumulative `left` offset for a sticky column based on the widths
// of preceding sticky+visible columns in the same context. Sticky columns must
// be contiguous at the start of the run, and any sticky column followed by
// another sticky column must declare an explicit `width`.
export default function stickyLeftOffset(columns, index) {
  if (!columns?.[index]?.sticky) return undefined;
  const widths = columns
    .slice(0, index)
    .filter((c) => c?.sticky && c?.isVisible && c?.width)
    .map((c) => c.width);
  return widths.length ? `calc(${widths.join(' + ')})` : '0';
}
